import React, { Component } from 'react';
import { Form, Input, Col, Row, InputNumber, Upload, Icon, Popconfirm, message, DatePicker, Select } from 'antd';
import DetailTitle from '../../../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../../../components/Custom';
import TextArea from 'antd/lib/input/TextArea';
import { contractSource, dicRentContractFirstLastRentType, paymentDate } from '../../../../../../axios/dictionaries'
import { uploadEnclosure, postFrom, config } from '../../../../../../axios'
import moment from 'moment';
import "../index.less";
import { moneyAddComma } from '../../../../../../utils';

const Option = Select.Option;

class SigningMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            InputWidth: "185px",
            shortInputWidth: "135px",
            isPaper: false,
            isAttachType: null,               // 1为普通附件  5为纸质合同
            contractUrl: '', //电子合同下载地址
        }
    }


    uploadEnclosure = (name, res) => { //上传附件

        let { data } = this.props;

        if (data['paperAttachList'] instanceof Array) {
            data['paperAttachList'].push({ fileName: name, id: res.attach_id, url: res.attach_url, attachType: this.state.isAttachType });
        } else {
            data['paperAttachList'] = [{ fileName: name, id: res.attach_id, url: res.attach_url, attachType: this.state.isAttachType }];
        }
        this.setState({ data });
    }

    handleDeleteAttach = (index, name) => { //删除附件
        let { data } = this.props;

        if (name === "paper") {
            data.paperAttachList.splice(index, 1);
        } else {
            data.attachList.splice(index, 1);
        }
        this.setState({ data });
    }

    handleGetContractUrl = (attachType) => { //获取下载电子合同的地址
        let { data } = this.props;
        if (data.signStatus === 2 && data.contractType === 1) {
            let params = { rentContractId: data.id, attachType };
            postFrom({ url: config.API_rentcontract_getContractFileUrl, data: params }).then(res => {
                this.setState({ contractUrl: res }, () => {
                    this.contractUrlRef.click();
                });
            }).catch(err => {
                message.error(err.message || '获取电子合同失败');
            })
        } else {
            message.error('已签的电子合同方能下载查看')
        }
    }

    handleGetPreviewUrl = () => { //预览
        let { data } = this.props;
        postFrom({ url: config.API_rentcontract_getPreviewUrl, data: { rentContractId: data.id } }).then(res => {
            this.setState({ contractUrl: res.url }, () => {
                this.contractUrlRef.click();
            });
        }).catch(err => {
            message.error(err.message || '获取预览合同失败');
        })
    }

    render() {
        let { form: { getFieldDecorator }, data } = this.props;
        let houseGoods = "";

        let {
            contractUrl
        } = this.state;

        let contractSources = data instanceof Object ? contractSource.find(item => data.contractSource === item.value) : null

        return (
            <div className="custom" style={{ paddingBottom: "20px" }}>
                <CustomRow title="房源">
                    <CustomCol label="楼栋/楼盘" required={false} >
                        <Input
                            disabled={true}
                            value={data.buildingName}
                        />
                    </CustomCol>
                    <CustomCol label="房间号" required={false} >
                        <Input
                            disabled={true}
                            value={data.roomNo}
                        />
                    </CustomCol>
                </CustomRow>

                <CustomRow divider title="合同">
                    <CustomCol label="签约类型" required={false} >
                        <Input
                            disabled={true}
                            value={contractSources ? contractSources.title : null}
                        />
                    </CustomCol>
                    {
                        // 如果为补录 , 则显示账单生成日和是否创建电子合同
                        contractSources && contractSources.value === 4 &&
                        <React.Fragment>
                            <CustomCol label="账单生成日" required={false} >
                                <Input
                                    disabled={ true }
                                    value={ data.billBeginDate ? moment(data.billBeginDate).format('YYYY-MM-DD') : "" }
                                />
                            </CustomCol>
                            <CustomCol label="创建电子合同" required={false} >
                                <Input
                                    disabled={ true }
                                    value={ data.createElectronicContract ? "是" : "否" }
                                />
                            </CustomCol>
                        </React.Fragment>



                    }

                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="起租日" required={false} >
                        <Input
                            disabled={true}
                            value={data.beginDate ? moment(data.beginDate).format('YYYY-MM-DD') : ""}
                        />
                    </CustomCol>
                    <CustomCol label="到期日" required={false} >
                        <Input
                            disabled={true}
                            value={data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : ""}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="常规押金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                        <Input
                            disabled={true}
                            value={moneyAddComma(data.normalDeposit)}
                        />
                    </CustomCol>
                    <CustomCol label="门卡押金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                        <Input
                            disabled={true}
                            value={moneyAddComma(data.doorCardDeposit)}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                        <Input
                            disabled={true}
                            value={moneyAddComma(data.monthlyFee)}
                        />
                    </CustomCol>
                    <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                        <Input
                            disabled={true}
                            value={moneyAddComma(data.networkFee)}
                        />
                    </CustomCol>
                    <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                        <Input
                            disabled={true}
                            value={moneyAddComma(data.propertyFee)}
                        />
                    </CustomCol>
                    <CustomCol label="零散租期" required={false}>
                        <Input
                            disabled={true}
                            value={
                                data.firstLastRentType
                                    ? dicRentContractFirstLastRentType.filter(item => {
                                        return data.firstLastRentType === item.value
                                    })[0].title
                                    : ""
                            }
                        />
                    </CustomCol>

                </CustomRow>
                {
                    data.firstLastRentType == 2
                        ? <React.Fragment>
                            <CustomRow divider title={true}>
                                <CustomCol label="首期" required={false}>
                                    <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                        <Input
                                            disabled={true}
                                            value={data.firstRentStartDate ? moment(data.firstRentStartDate).format('YYYY-MM-DD') : ""}
                                        />
                                        <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: '#f5f5f5' }}>至</span>
                                        <Input
                                            disabled={true}
                                            value={data.firstRentEndDate ? moment(data.firstRentEndDate).format('YYYY-MM-DD') : ""}
                                        />
                                    </div>
                                </CustomCol>
                                <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.firstRentFee)}
                                    />
                                </CustomCol>
                                <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.firstRentNetworkFee)}
                                    />
                                </CustomCol>
                                <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.firstRentPropertyFee)}
                                    />
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider title={true}>
                                <CustomCol label="末期" required={false}>
                                    <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                        <Input
                                            disabled={true}
                                            value={data.lastRentStartDate ? moment(data.lastRentStartDate).format('YYYY-MM-DD') : ""}
                                        />
                                        <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: '#f5f5f5' }}>至</span>
                                        <Input
                                            disabled={true}
                                            value={data.lastRentEndDate ? moment(data.lastRentEndDate).format('YYYY-MM-DD') : ""}
                                        />
                                    </div>
                                </CustomCol>
                                <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.lastRentFee)}
                                    />
                                </CustomCol>
                                <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.lastRentNetworkFee)}
                                    />
                                </CustomCol>
                                <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                    <Input
                                        disabled={true}
                                        value={moneyAddComma(data.lastRentPropertyFee)}
                                    />
                                </CustomCol>
                            </CustomRow>
                        </React.Fragment>
                        : null
                }
                <CustomRow divider title={true}>
                    <CustomCol label="付款日" required={false}>
                        <Input
                            disabled={true}
                            value={`每月${data.payDay}日`}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="房间物品" labelStyle={{ height: '100px' }} colStyle={{ width: "500px" }} height="100px" required={false}  >
                        {getFieldDecorator('furnitureList', {
                            rules: [{
                                required: false, message: '请输入',
                            }],
                            initialValues: data.furnitureList instanceof Array && data.furnitureList ? data.furnitureList.map((item, index) => {
                                if (index === data.furnitureList.length - 1) {
                                    houseGoods += `${item.name}×${item.amount}`
                                } else {
                                    houseGoods += `${item.name}×${item.amount}、`
                                }
                            }) : "",
                            initialValue: houseGoods
                        })(
                            <TextArea
                                rows={3}
                                cols={10}
                                placeholder={'请输入'} disabled={true}
                                style={{ height: '100px' }}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="合同补充条款" labelStyle={{ height: '100px' }} colStyle={{ width: "500px" }} height="100px" required={false}>
                        <TextArea
                            disabled={true}
                            style={{ height: '100px' }}
                            value={data.contractRemark}
                        />
                    </CustomCol>
                </CustomRow>
                {
                    data.contractType === 1 ?
                        <CustomRow divider title="办理">
                            <CustomCol label="签约类型" required={false}>
                                <Input
                                    disabled={true}
                                    value={data.contractType ? data.contractType === 1 ? "电子" : "纸质" : ""}
                                />
                            </CustomCol>
                            <CustomCol label="合同编号" required={false}>
                                <Input
                                    disabled={true}
                                    value={data.contractNo}
                                />
                            </CustomCol>
                            <CustomCol label="电子合同" required={false}>
                                <Input
                                    disabled={true}
                                    value={data.contractTemplateName}
                                />
                            </CustomCol>
                            <div className="flex-static" style={{ marginLeft: "10px" }}>
                                {
                                    data.signStatus === 1
                                        ? data.contractSource === 4 && !data.createElectronicContract ?
                                            null :
                                            <span className="showClickDetail" onClick={this.handleGetPreviewUrl}>预览合同</span>
                                        : data.signStatus === 2
                                            ? <React.Fragment>
                                                <span className="showClickDetail" onClick={this.handleGetContractUrl.bind(this, 6)}>查看合同</span>
                                                <span className="showClickDetail" style={{ marginLeft: "10px" }} onClick={this.handleGetContractUrl.bind(this, 7)}>查看合同附页</span>
                                            </React.Fragment>
                                            : null
                                }
                                <a
                                    href={contractUrl}
                                    download
                                    ref={ref => this.contractUrlRef = ref}
                                    style={{ display: 'none' }}
                                    target="_blank"
                                ></a>
                            </div>
                        </CustomRow>
                        :
                        data.contractType === 2 ?
                            <CustomRow divider title={true}>
                                <CustomCol label="合同类型" required={false}>
                                    <Input
                                        disabled={true}
                                        value={data.contractType ? data.contractType === 1 ? "电子" : "纸质" : ""}
                                    />
                                </CustomCol>
                                <CustomCol label="合同编号" required={false}>
                                    <Input
                                        disabled={true}
                                        value={data.contractNo}
                                    />
                                </CustomCol>
                                <CustomCol label="纸质合同" required={false} >
                                    <span
                                        style={{
                                            display: 'block',
                                            padding: '0 11px',
                                            height: '100%',
                                            color: data.paperAttachList instanceof Array && data.paperAttachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                            whiteSpace: 'nowrap',
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                        }}
                                    >
                                        {
                                            data.paperAttachList instanceof Array && data.paperAttachList.length
                                                ? data.paperAttachList.map((item, index) => {
                                                    if (item.attachType == 5) {
                                                        return <span key={index}>
                                                            <a
                                                                href={item.fileUrl}
                                                                download
                                                                className="showClickDetail"
                                                                style={{ color: 'inherit' }}
                                                                target="_blank"
                                                            >{item.fileName}；</a>
                                                            <Popconfirm
                                                                placement="topRight"
                                                                title={'此删除操作不可恢复，确定删除吗？'}
                                                                onConfirm={() => {
                                                                    this.handleDeleteAttach(index, 'paper')
                                                                }}
                                                                okText="删除"
                                                                cancelText="取消"
                                                            >
                                                                <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                                                    <Icon type="close" />
                                                                </span>
                                                            </Popconfirm>
                                                        </span>
                                                    }

                                                })
                                                : "未上传"
                                        }
                                    </span>
                                </CustomCol>
                                <div className="center" style={{ marginLeft: '10px' }} onClick={() => { this.setState({ isAttachType: 5 }) }}>
                                    <Upload {...uploadEnclosure({ accept: '', tableName: 'rent_contract', success: this.uploadEnclosure, attachType: 5, rowId: data.id })}>
                                        <span className="showClickDetail">上传</span>
                                    </Upload>
                                </div>
                            </CustomRow>
                            : ""
                }
                <CustomRow divider title={true}>
                    <CustomCol label="附件" required={false} colStyle={{ width: '500px' }}>
                        <span
                            style={{
                                display: 'block',
                                padding: '0 11px',
                                height: '100%',
                                color: data.attachList instanceof Array && data.attachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                whiteSpace: 'nowrap',
                                overflowX: 'auto',
                                overflowY: 'hidden',
                            }}
                        >
                            {
                                data.attachList instanceof Array && data.attachList.length
                                    ? data.attachList.map((item, index) => {
                                        if (item.attachType == 1) {
                                            return <span key={index}>
                                                <a
                                                    href={item.fileUrl}
                                                    download
                                                    className="showClickDetail"
                                                    style={{ color: 'inherit' }}
                                                    target="_blank"
                                                >{item.fileName}；</a>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        this.handleDeleteAttach(index, 'Enclosure')
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                                        <Icon type="close" />
                                                    </span>
                                                </Popconfirm>
                                            </span>
                                        }

                                    })
                                    : "未上传"
                            }
                        </span>
                    </CustomCol>
                    <div className="center" style={{ marginLeft: '10px' }} onClick={() => { this.setState({ isAttachType: 1 }) }}>
                        <Upload {...uploadEnclosure({ accept: '', tableName: 'rent_contract', success: this.uploadEnclosure, rowId: data.id })}>
                            <span className="showClickDetail">上传</span>
                        </Upload>
                    </div>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="办理部门" required={false}>
                        <Input
                            disabled={true}
                            value={data.merchantDepartmentName}
                        />
                    </CustomCol>
                    <CustomCol label="办理人" required={false}>
                        <Input
                            disabled={true}
                            value={data.merchantUserName}
                        />
                    </CustomCol>
                    <CustomCol label="办理日期" required={false}>
                        <Input
                            disabled={true}
                            value={data.signDate ? moment(data.signDate).format('YYYY-MM-DD') : ""}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider title={true}>
                    <CustomCol label="办理备注" required={false} colStyle={{ width: '500px' }}>
                        <Input
                            disabled={true}
                            value={data.remark}
                        />
                    </CustomCol>
                </CustomRow>

            </div>
        )
    }
}

export default Form.create()(SigningMessage)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/SigningMessage/index.js